import * as React from 'react'

import { inject, observer } from 'mobx-react'

import { PhoneInput } from '~/client/src/shared/components/PhoneInput'

import InitialState from '../../stores/InitialState'
import { getPhoneCountry } from '../../utils/phoneNumberValidation'
import { EMPTY_STRING } from '../../utils/usefulStrings'
import BaseStruxhubInput, { ISharedProps } from './BaseStruxhubInput'

// Legacy field chrome (label, required/changed markers, helper text) around the canonical
// PhoneInput, for forms still built on Struxhub inputs.
interface IProps extends Omit<ISharedProps, 'value'> {
  value?: string
  onChange: (phoneNumber: string) => void
  onFocus?: () => void
  onBlur?: () => void
  onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void
  id?: string
  name?: string

  state?: InitialState
}

@inject('state')
@observer
export default class StruxhubPhoneInput extends React.Component<IProps> {
  public render() {
    const {
      value,
      state,
      onChange,
      onPaste,
      isRequired,
      isReadOnly,
      id,
      name,
      testId,
    } = this.props

    return (
      <BaseStruxhubInput {...this.props}>
        {(isValueInvalid, _isInFocus, onFocus, onBlur) => (
          <PhoneInput
            id={id}
            name={name}
            value={value || EMPTY_STRING}
            onChange={onChange}
            defaultCountry={getPhoneCountry(state.countryCode)}
            required={isRequired}
            disabled={isReadOnly}
            aria-invalid={isValueInvalid || undefined}
            data-testid={testId}
            onFocus={() => {
              onFocus()
              this.props.onFocus?.()
            }}
            onBlur={() => {
              onBlur()
              this.props.onBlur?.()
            }}
            onPaste={onPaste}
          />
        )}
      </BaseStruxhubInput>
    )
  }
}
